<template>
    <div>
        <div
            class="mb-8 dm-manuscript-illustration-thumbs"
            v-if="illustrations.length"
        >
            <div
                class="dm-manuscript-single-illustration"
                v-for="illustration in illustrations"
                :key="'illustration-' + illustration.name"
            >
                <img
                    :src="illustration.thumb_url"
                    @click="showFullImage(illustration.full_url)"
                />

                <button
                    class="btn btn-sm btn-icon btn-light-danger dm-delete-illustration"
                    v-if="editable"
                    @click="deleteIllustration(illustration.id)"
                >
                    <i class="icon-lg las la-times"></i>
                </button>
            </div>
        </div>
        <div v-if="editable">
            <UploadIllustration
                :presentation_id="presentation_id"
                @illustrationUploaded="$emit('illustrationUploaded')"
            />
        </div>
    </div>
</template>

<script>
import UploadIllustration from "./illustrations-list/UploadIllustration.vue";

export default {
    components: { UploadIllustration },

    props: ["illustrations", "editable", "presentation_id"],

    data() {
        return {
            colleagues: [],
        };
    },
    methods: {
        showFullImage(imageUrl) {
            this.$swal({
                html: "<img src='" + imageUrl + "'>",
                confirmButtonText: "Close",
                didOpen: function (dObj) {
                    $(".swal2-popup").css("width", "52em");
                    $(".swal2-container .swal2-html-container").css(
                        "max-height",
                        "none",
                    );
                },
                content: true,
                animation: false,
            });
        },
        deleteIllustration(illustrationId) {
            var self = this;
            axios
                .delete(
                    "/api/author/presentations/" +
                        this.presentation_id +
                        "/illustrations/" +
                        illustrationId,
                )
                .then(function (response) {
                    self.$emit("illustrationDeleted");
                    self.showSwalSuccessPopup();
                });
        },
    },
};
</script>
